import { render, staticRenderFns } from "./ListDivisoes.vue?vue&type=template&id=30d1a114&scoped=true"
import script from "./ListDivisoes.vue?vue&type=script&lang=js"
export * from "./ListDivisoes.vue?vue&type=script&lang=js"
import style0 from "./ListDivisoes.vue?vue&type=style&index=0&id=30d1a114&prod&lang=scss"
import style1 from "./ListDivisoes.vue?vue&type=style&index=1&id=30d1a114&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30d1a114",
  null
  
)

export default component.exports